// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// ** API Imports
import axios from '@src/service/axios';

// ** Toast Imports
import { toast } from 'react-toastify';

// Get All job Execution data
export const getJobExecution = createAsyncThunk('jobExecutionSlice/getJobExecution', async () => {
    try {
        const response = await axios.get('/scheduler/job-execution', {
            headers: {
                'Content-Type': 'application/json'
            }
        });

        return response.data;
    } catch (err) {
        console.log('err', err);

        toast.error(err?.response?.data?.message || 'Something went wrong!');

        throw err;
    }
});

export const manualRunJob = createAsyncThunk('jobExecutionSlice/manualRunJob', async (data, { dispatch }) => {
    try {
        const response = await axios.post('/scheduler/manual-run', data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });

        toast.success(response?.data?.message || 'Job execution started successfully!');

        dispatch(getJobExecution());

        return response.data;
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Failed to start job execution!');
        throw err;
    }
});

export const jobExecutionSlice = createSlice({
    name: 'jobExecutionSlice',
    initialState: {
        jobExecution: [],
        loading: false,
        error: null
    },
    extraReducers: (builder) => {
         builder.addCase(getJobExecution.fulfilled, (state, action) => {
            state.jobExecution = action.payload;
        });
    }
});

export default jobExecutionSlice.reducer;
